import { useState } from 'react';

export const useConfirmationModal = () => {
    const [modalState, setModalState] = useState({
        isOpen: false,
        title: '',
        message: '',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        type: 'warning',
        onConfirm: () => {},
        onCancel: () => {}
    });

    const [inputModalState, setInputModalState] = useState({
        isOpen: false,
        title: '',
        message: '',
        placeholder: '',
        defaultValue: '',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        type: 'info',
        onConfirm: () => {},
        onCancel: () => {}
    });

    const showModal = ({
        title = "Confirmação",
        message,
        confirmText = "Confirmar",
        cancelText = "Cancelar",
        type = "warning",
        onConfirm = () => {},
        onCancel = () => {}
    }) => {
        return new Promise((resolve) => {
            setModalState({
                isOpen: true,
                title,
                message,
                confirmText,
                cancelText,
                type,
                onConfirm: () => {
                    setModalState(prev => ({ ...prev, isOpen: false }));
                    onConfirm();
                    resolve(true);
                },
                onCancel: () => {
                    setModalState(prev => ({ ...prev, isOpen: false }));
                    onCancel();
                    resolve(false);
                }
            });
        });
    };

    const hideModal = () => {
        setModalState(prev => ({ ...prev, isOpen: false }));
    };

    // Funções de conveniência
    const showSuccess = (message, title = "Sucesso") => {
        return showModal({
            title,
            message,
            type: "success",
            confirmText: "OK",
            cancelText: "",
            onCancel: () => {} // Não mostra botão cancelar
        });
    };

    const showError = (message, title = "Erro") => {
        return showModal({
            title,
            message,
            type: "error",
            confirmText: "OK",
            cancelText: "",
            onCancel: () => {}
        });
    };

    const showInfo = (message, title = "Informação") => {
        return showModal({
            title,
            message,
            type: "info",
            confirmText: "OK",
            cancelText: "",
            onCancel: () => {}
        });
    };

    const showWarning = (message, title = "Aviso") => {
        return showModal({
            title,
            message,
            type: "warning",
            confirmText: "OK",
            cancelText: "",
            onCancel: () => {}
        });
    };

    const showConfirm = (message, title = "Confirmação") => {
        return showModal({
            title,
            message,
            type: "warning",
            confirmText: "Sim",
            cancelText: "Não"
        });
    };

    const showInput = ({
        title = "Entrada",
        message,
        placeholder = "",
        defaultValue = "",
        confirmText = "Confirmar",
        cancelText = "Cancelar",
        type = "info"
    }) => {
        return new Promise((resolve) => {
            setInputModalState({
                isOpen: true,
                title,
                message,
                placeholder,
                defaultValue,
                confirmText,
                cancelText,
                type,
                onConfirm: (value) => {
                    setInputModalState(prev => ({ ...prev, isOpen: false }));
                    resolve(value);
                },
                onCancel: () => {
                    setInputModalState(prev => ({ ...prev, isOpen: false }));
                    resolve(null);
                }
            });
        });
    };

    return {
        modalState,
        inputModalState,
        showModal,
        hideModal,
        showSuccess,
        showError,
        showInfo,
        showWarning,
        showConfirm,
        showInput
    };
};
